import { Dialog } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { ChefEntrepriseSelector, IChefEntrepriseSelectorProps } from ".";
import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

const StyledDialog = styled(Dialog)`
  width: 1100px;
  height: auto;
  background-color: white;
`;

export interface IChefEntrepriseSelectorDialogProps extends IChefEntrepriseSelectorProps {
  onClosed: (selectedChefEntrepriseIds?: number[]) => void;
  selectorDialogOpen: boolean;
  idsiegeSocial?: number;
  canAdd?: boolean;
  filterOnSiegeSocial?: boolean;
}

export const ChefEntrepriseSelectorDialog: React.FunctionComponent<IChefEntrepriseSelectorDialogProps> = ({
  onClosed,
  selectorDialogOpen,
  filterOnSiegeSocial,
  ...otherProps
}) => {
  const { t } = useTl();

  return (
    <StyledDialog
      title={t(ETLCodes.SearchChefEntreprises)}
      isOpen={selectorDialogOpen}
      enforceFocus={false}
      onClose={() => onClosed(null)}
    >
      <ChefEntrepriseSelector {...otherProps} filterOnSiegeSocial={filterOnSiegeSocial} />
    </StyledDialog>
  );
};
